import { ComponentType, HTMLProps } from 'react'

import { FieldInputProps } from 'formik'
import { NumericFormatProps } from 'react-number-format'
import styled from 'styled-components'

interface OwnProps {
  error?: boolean
  type?: 'text' | 'password' | 'tel'
  as?: keyof React.JSX.IntrinsicElements | ComponentType<any>
}

declare type Props = (FieldInputProps<any> | HTMLProps<HTMLInputElement | HTMLSelectElement> | NumericFormatProps) & OwnProps

const Input = styled.input<Props>`
  appearance: none;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.publicBgLight};
  border: 2px solid ${({ theme }) => theme.colors.publicNavyLight};
  border-radius: 5px;
  font-family: ${({ theme }) => theme.fonts.textFont};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.paragraph};
  padding: 0 ${({ theme }) => theme.space.S16};
  height: 62px;
  white-space: nowrap;
  text-overflow: ellipsis;

  &::-ms-clear {
    display: none;
  }

  &:focus,
  &:hover {
    border-color: ${({ theme }) => theme.colors.publicPurple};
    outline: none;
  }

  ${({ theme, error }) =>
    error &&
    `
    border-color: ${theme.colors.publicRust};
  `}
`

export default Input
